import type { FilterTypeLabels } from './types'

export const mapLabelsToCheckboxOptions = (labels: FilterTypeLabels) =>
  Object.entries(labels).map(([key, value]) => {
    return {
      label: value,
      value: key,
    }
  })
